import { Box } from '@mui/material';
import FullPageLoadingSplash from '@acorn-portal/shared/src/components/loading/FullPageLoadingSplash';
import { FC, useEffect } from 'react';

const LogOutPage: FC = () => {
	useEffect(() => {
		const timer = setTimeout(() => {
			window.location.reload();
		}, 1000);

		return () => clearTimeout(timer);
	}, []);

	return (
		<FullPageLoadingSplash message='Logging out...' loading>
			<Box sx={{ display: 'hidden' }}>Logging out</Box>
		</FullPageLoadingSplash>
	);
};

export default LogOutPage;
